import type { ISupportedLanguagesAndLocale } from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import { SearchEngineLanguagePicker } from "app/components/campaigns/searchEngine/inputFields/SearchEngineLanguagePicker";
import type { ICampaignsLanguage } from "app/components/campaigns/searchEngine/SearchEnginesConsts";
import CountryService from "app/services/CountryService";

import { LanguagePickerWrapper } from "./styles";

type Props = {
    languagesList: ISupportedLanguagesAndLocale[];
    selectedCountryCode: string | undefined;
    selectedLanguage: ICampaignsLanguage | undefined;
    onSelect: (language: ICampaignsLanguage) => void;
    isDisabled?: boolean;
};

export const LanguagePicker = ({
    languagesList,
    selectedCountryCode,
    selectedLanguage,
    onSelect,
    isDisabled = false,
}: Props) => {
    // Convert country code to country name for SearchEngineLanguagePicker
    const selectedCountryName = selectedCountryCode
        ? CountryService.getCountryByCode(selectedCountryCode)?.text
        : undefined;

    return (
        <LanguagePickerWrapper data-automation="gsc-language-picker">
            <SearchEngineLanguagePicker
                selectedCountryName={selectedCountryName}
                selectedLanguage={selectedLanguage}
                onSelect={onSelect}
                languagesList={languagesList}
                isDisabled={isDisabled || !selectedCountryCode}
                dropdownWidth={174}
            />
        </LanguagePickerWrapper>
    );
};
